import { useEffect, useState } from "react";
import { compose } from "redux";
import { Form } from "antd";
import _ from "lodash";
import moment from "moment"

import WithHOC from "./actions";
import CoreRenderFunction from "DisplayCore";
import { WalletUploadListLayout } from "PageLayout/Wallet/WalletUploadList";

const WalletUploadList = (props) => {
  const {
    query,
    meta,
    uploadedFileInfo,
    onChangeHOC,
    getList,
    bulkUploadWalletAction,
    viewWalletStatementUploadDetail,
    modulePermissions,
  } = props;
  const { can_read, can_create, can_update } = modulePermissions;

  const [selected, setSelected] = useState({});
  const [filterForm] = Form.useForm();
  const [bulkUploadForm] = Form.useForm();

  useEffect(() => {
    if (!_.isEmpty(props.selected)) {
      setSelected({ 
        ...props.selected, 
        createdAt: moment(props.selected.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        status: _.startCase(props.selected.status.replaceAll("_", " ")),
        type: _.startCase(props.selected.type.replaceAll("_", " "))
      });
    } else {
      setSelected({});
    }
  }, [props.selected])

  useEffect(() => {
    getList();
  }, [query]);
  

  const onClickAction = (actionKey, ...args) => {
    switch (actionKey) {
      case 'UPDATE_TABLE_INFO':
        switch( args[0] ) {
          case 'page':
            if(meta.page !== args[1] ){
              onChangeHOC("query", { ...query, page: args[1] })
            }
            break
          case 'pageSize':
            if(meta.page_size !== args[1] ){
              onChangeHOC("query", { ...query, page_size: args[1] })
            }
            break
          default:
        }
        break
      case 'OPEN_BULK_UPLOAD_MODAL':
        onChangeHOC('action', 'bulk_upload');
        break;
      case "CLOSE_BULK_UPLOAD_MODAL":
        onChangeHOC("action", null);
        onChangeHOC("uploadedFileInfo", {});
        break;
      case "UPLOAD_FILE":
        if( args[0] && args[0].length > 0 ) {
          const reader = new FileReader()
          reader.onload = () => {
            onChangeHOC('uploadedFileInfo', {
                base64: reader.result,
                file_name: args[0][0].filename
              }
            )
          }
          reader.readAsDataURL( args[0][0].file )
        }
        break
      default:
        break;
      case 'CLOSE_VIEW_MODAL':
        onChangeHOC('action', null);
        onChangeHOC('selected', {});
        break;
      case 'APPROVE_SELECTED':
        if (can_update) {
          onChangeHOC('showPinVerification', true)
          onChangeHOC('uploadAction', 'approve')
        }
        break;
      case 'REJECT_SELECTED':
        if (can_update) {
          onChangeHOC('showPinVerification', true)
          onChangeHOC('uploadAction', 'reject')
        }
        break;
      case 'CLOSE_PIN_MODAL':
        onChangeHOC('action', null)
        onChangeHOC('showPinVerification', false)
        break;
      case 'RESET_FILTER':
        onChangeHOC("query", { ...query, filter: {}, page: 1 });
        filterForm.resetFields();
        break;
      case 'ACTIONS':
        switch (args[0].key) {
          case 'view':
            viewWalletStatementUploadDetail(args[1].original.id)
            break
          default:
        }
        break
    }
  }

  const hideComponent = (actionKey) => {
    switch (actionKey) {
      case "noCreatePermission":
        return !can_create;
      case "hideApprovalButtons":
        return !can_update || !props.data.ProfileReducer.profile.is_department_head || (_.isEmpty(props.selected) ? false : props.selected.status !== 'pending'); // or not head of department
      default:
        return false;
    }
  };

  const onSubmitFilterForm = (formData) => {
    const tmpFilter = {
      ...query.filter,
      ...formData
    }

    onChangeHOC("query", { ...query, filter: tmpFilter, page: 1 });
  }

  const onSubmitBulkUploadForm = (formData) => {
    bulkUploadWalletAction({
      remarks: uploadedFileInfo.file_name.replace(/.[^/.]+$/, ''),
      transaction_type: formData.transaction_type,
      base64: uploadedFileInfo.base64.split("base64,")[1],
      wallet_type_id: 2
    })
  }

  return (
    <>
      {can_read && (
        <CoreRenderFunction
          {...props}
          item={WalletUploadListLayout.content}
          onClickAction={onClickAction}
          hideComponent={hideComponent}
          isView={props.action === 'view'}
          isBulkUpload={props.action === 'bulk_upload'}
          selected={selected}
          filterForm={filterForm}
          onSubmitFilterForm={onSubmitFilterForm}
          bulkUploadForm={bulkUploadForm}
          onSubmitBulkUploadForm={onSubmitBulkUploadForm}
        />
      )}
    </>
  );
};

export default compose(WithHOC)(WalletUploadList);
